import { ModuleFE_RuntimeSmartNote } from './ModuleFE_RuntimeSmartNote.js';
export const ModulePackFE_RuntimeSmartNoteDB = [ModuleFE_RuntimeSmartNote];
//# sourceMappingURL=module-pack.js.map